function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pointer = function Pointer(nativePointer) {
  _classCallCheck(this, Pointer);

  this.id = self.Touch && nativePointer instanceof Touch ? nativePointer.identifier : -1;
  this.pageX = nativePointer.pageX;
  this.pageY = nativePointer.pageY;
  this.clientX = nativePointer.clientX;
  this.clientY = nativePointer.clientY;
};

var getDistance = function getDistance(a, b) {
  if (!b) {
    return 0;
  }

  return Math.sqrt(Math.pow(b.clientX - a.clientX, 2) + Math.pow(b.clientY - a.clientY, 2));
};

var getMidpoint = function getMidpoint(a, b) {
  if (!b) {
    return a;
  }

  return {
    clientX: (a.clientX + b.clientX) / 2,
    clientY: (a.clientY + b.clientY) / 2
  };
};

var isTouchEvent = function isTouchEvent(event) {
  return "changedTouches" in event;
};

var PointerTracker = /*#__PURE__*/function () {
  function PointerTracker(_element) {
    var _this = this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$start = _ref.start,
        start = _ref$start === void 0 ? function () {
      return true;
    } : _ref$start,
        _ref$move = _ref.move,
        move = _ref$move === void 0 ? function () {} : _ref$move,
        _ref$end = _ref.end,
        end = _ref$end === void 0 ? function () {} : _ref$end;

    _classCallCheck(this, PointerTracker);

    this._element = _element;
    this.startPointers = [];
    this.currentPointers = [];

    this._pointerStart = function (event) {
      if (event.buttons > 0 && event.button !== 0) {
        return;
      }

      var pointer = new Pointer(event);

      if (_this.currentPointers.some(function (p) {
        return p.id === pointer.id;
      })) {
        return;
      }

      if (!_this._triggerPointerStart(pointer, event)) {
        return;
      }

      window.addEventListener("mousemove", _this._move);
      window.addEventListener("mouseup", _this._pointerEnd);
    };

    this._touchStart = function (event) {
      for (var _i = 0, _Array$from = Array.from(event.changedTouches || []); _i < _Array$from.length; _i++) {
        var touch = _Array$from[_i];

        _this._triggerPointerStart(new Pointer(touch), event);
      }
    };

    this._move = function (event) {
      var previousPointers = _this.currentPointers.slice();

      var changedPointers = isTouchEvent(event) ? Array.from(event.changedTouches).map(function (t) {
        return new Pointer(t);
      }) : [new Pointer(event)];
      var trackedChangedPointers = [];

      var _iterator = _createForOfIteratorHelper(changedPointers),
          _step;

      try {
        var _loop = function _loop() {
          var pointer = _step.value;

          var index = _this.currentPointers.findIndex(function (p) {
            return p.id === pointer.id;
          });

          if (index < 0) {
            return "continue";
          }

          trackedChangedPointers.push(pointer);
          _this.currentPointers[index] = pointer;
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_ret === "continue") continue;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      _this._moveCallback(previousPointers, _this.currentPointers.slice(), event);
    };

    this._triggerPointerEnd = function (pointer, event) {
      var index = _this.currentPointers.findIndex(function (p) {
        return p.id === pointer.id;
      });

      if (index < 0) {
        return false;
      }

      _this.currentPointers.splice(index, 1);

      _this.startPointers.splice(index, 1);

      _this._endCallback(pointer, event);

      return true;
    };

    this._pointerEnd = function (event) {
      if (event.buttons > 0 && event.button !== 0) {
        return;
      }

      if (!_this._triggerPointerEnd(new Pointer(event), event)) {
        return;
      }

      window.removeEventListener("mousemove", _this._move, {
        passive: false
      });
      window.removeEventListener("mouseup", _this._pointerEnd, {
        passive: false
      });
    };

    this._touchEnd = function (event) {
      for (var _i2 = 0, _Array$from2 = Array.from(event.changedTouches || []); _i2 < _Array$from2.length; _i2++) {
        var touch = _Array$from2[_i2];

        _this._triggerPointerEnd(new Pointer(touch), event);
      }
    };

    this._startCallback = start;
    this._moveCallback = move;
    this._endCallback = end;

    this._element.addEventListener("mousedown", this._pointerStart, {
      passive: false
    });

    this._element.addEventListener("touchstart", this._touchStart, {
      passive: false
    });

    this._element.addEventListener("touchmove", this._move, {
      passive: false
    });

    this._element.addEventListener("touchend", this._touchEnd);

    this._element.addEventListener("touchcancel", this._touchEnd);
  }

  _createClass(PointerTracker, [{
    key: "stop",
    value: function stop() {
      this._element.removeEventListener("mousedown", this._pointerStart, {
        passive: false
      });

      this._element.removeEventListener("touchstart", this._touchStart, {
        passive: false
      });

      this._element.removeEventListener("touchmove", this._move, {
        passive: false
      });

      this._element.removeEventListener("touchend", this._touchEnd);

      this._element.removeEventListener("touchcancel", this._touchEnd);

      window.removeEventListener("mousemove", this._move);
      window.removeEventListener("mouseup", this._pointerEnd);
    }
  }, {
    key: "_triggerPointerStart",
    value: function _triggerPointerStart(pointer, event) {
      if (!this._startCallback(pointer, event)) {
        return false;
      }

      this.currentPointers.push(pointer);
      this.startPointers.push(pointer);
      return true;
    }
  }]);

  return PointerTracker;
}();

export { PointerTracker, getDistance, getMidpoint };